// import { Component, OnInit } from "@angular/core";
// import { ActivatedRoute, Router } from "@angular/router";

// @Component({
//   selector: "app-recordtypepicklist",
//   templateUrl: "./recordtypepicklist.component.html",
//   styleUrls: ["./recordtypepicklist.component.scss"],
// })
// export class RecordtypepicklistComponent implements OnInit {
//   // Form data
//   fieldLabel: string = "";
//   recordType: string = "";
//   attributes: any;

//   // Picklist data
//   availableValues: string[] = [];
//   selectedValues: string[] = [];

//   // Dropdown options
//   recordTypeOptions: string[] = ["International", "Domestic", "Regional"];

//   constructor(
//     private route: ActivatedRoute,
//     private router: Router // private fb: FormBuilder, // private appConfig: AppConfig, // private dataService: DataService
//   ) {}
//   ngOnInit(): void {
//     this.route.queryParams.subscribe((params) => {
//       // this.recordTypeId = this.route.snapshot.params.id;
//       this.recordType = this.route.snapshot.params.name;
//       // this.metaobjectId = this.route.snapshot.params.metaobjectid;
//       // this.metaobjectName = this.route.snapshot.params.metaobjectname;
//       this.fieldLabel = this.route.snapshot.params.fieldname;
//       // this.attributes = this.route.snapshot.params.attributes;
//       this.attributes = JSON.parse(params["attributes"]) || {};
//     });
//     this.availableValues.push(
//       ...this.attributes.options.map((option) => option.value)
//     );

//     console.log("Record attributes:", this.attributes);
//   }

//   // Method to add item from available to selected
//   addToSelected(item: string): void {
//     if (
//       this.availableValues.includes(item) &&
//       !this.selectedValues.includes(item)
//     ) {
//       this.selectedValues.push(item);
//     }
//   }

//   // Method to remove item from selected
//   removeFromSelected(item: string): void {
//     const index = this.selectedValues.indexOf(item);
//     if (index > -1) {
//       this.selectedValues.splice(index, 1);
//     }
//   }

//   // Method to move item from available to selected
//   moveToSelected(): void {
//     // This would be triggered by the Add button or double-click
//     const selectedAvailable = this.availableValues[0]; // Assuming first item is selected
//     this.addToSelected(selectedAvailable);
//   }

//   // Method to handle help click
//   onHelpClick(): void {
//     console.log("Help clicked");
//     // Implement help functionality
//   }

//   // Method to handle record type change
//   onRecordTypeChange(value: string): void {
//     this.recordType = value;
//   }
// }

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "./../../guid";

@Component({
  selector: "app-recordtypepicklist",
  templateUrl: "./recordtypepicklist.component.html",
  styleUrls: ["./recordtypepicklist.component.scss"],
})
export class RecordtypepicklistComponent implements OnInit {
  // Form data
  fieldLabel: string = "";
  recordTypeName: string = "";
  attributes: any;

  // Picklist data
  availableValues: string[] = [];
  selectedValues: string[] = [];

  // Dropdown options
  recordTypeOptions: string[] = ["International", "Domestic", "Regional"];

  // For tracking the currently selected item
  selectedAvailable: string[] = [];
  selectedSelected: string[] = [];
  metaobjectId: any;
  metaobjectName: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  mode: string = "new"; // Default mode
  guid: GUID;

  recordTypeId: any;
  recordTypePicklistValueId: any;
  recordTypePicklistValue: any;

  constructor(
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    private route: ActivatedRoute,
    private router: Router // private fb: FormBuilder, // private appConfig: AppConfig, // private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.recordTypeName = this.route.snapshot.params.name;
      this.recordTypeId = this.route.snapshot.params.id;

      this.fieldLabel = this.route.snapshot.params.fieldname;

      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;

      this.attributes = JSON.parse(params["attributes"]) || {};
    });
    this.guid = new GUID();

    this.getRecordTypePicklistValueById();
    // Initialize available values based on attributes
    // this.availableValues.push(
    //   ...this.attributes.options.map((option) => option.value)
    // );
    // Only include options that are NOT in selectedValues

    console.log("Record attributes:", this.attributes);
  }
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  // Method to move selected item from Available to Selected
  moveToSelected(): void {
    // Add selected values to the selectedValues array
    this.selectedAvailable.forEach((value) => {
      if (!this.selectedValues.includes(value)) {
        this.selectedValues.push(value);
      }
    });

    // Remove the selected items from the availableValues
    this.availableValues = this.availableValues.filter(
      (value) => !this.selectedAvailable.includes(value)
    );

    // Reset the selectedAvailable array after moving items
    this.selectedAvailable = [];
  }

  // Method to move selected item from Selected to Available
  moveToAvailable(): void {
    // Add selected values to the availableValues array
    this.selectedSelected.forEach((value) => {
      if (!this.availableValues.includes(value)) {
        this.availableValues.push(value);
      }
    });

    // Remove the selected items from the selectedValues
    this.selectedValues = this.selectedValues.filter(
      (value) => !this.selectedSelected.includes(value)
    );

    // Reset the selectedSelected array after moving items
    this.selectedSelected = [];
  }

  // Method to handle record type change
  onRecordTypeChange(value: string): void {
    this.recordTypeName = value;
  }

  getRecordTypePicklistValueById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        recordtype: {
          recordtypepicklistvalue: {
            picklist: this.fieldLabel,
            recordtypeid: this.recordTypeId,
          },
        },
      },
    };

    this.isLoading = true;
    this.dataService.getRecordTypePicklistValueById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.recordTypePicklistValue = res.data.recordtypepicklistvalue;
          if (this.recordTypePicklistValue != null) {
            this.recordTypePicklistValueId = this.recordTypePicklistValue.id;
            // this.mode = this.recordTypePicklistValue.mode;
            this.selectedValues = this.recordTypePicklistValue.values || [];
            this.fieldLabel = this.recordTypePicklistValue.picklist;
            console.log("Selected values:", this.selectedValues);
            // Filter available values to exclude those already selected
            // const filteredOptions = this.attributes.options
            //   .map((option) => option.value)
            //   .filter((value) => !this.selectedValues.includes(value));
            // this.availableValues.push(...filteredOptions);
          }
          this.isLoading = false;
          const filteredOptions = this.attributes.options
            .map((option) => option.value)
            .filter((value) => !this.selectedValues.includes(value));

          this.availableValues.push(...filteredOptions);
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  save(): void {
    // Implement save functionality here
    console.log("Saving record type:", this.recordTypeName);
    console.log("Selected values:", this.selectedValues);
    console.log("Available values:", this.availableValues);
    this.isLoading = false;
    this.isError = false;
    // if (this.selectedValues.length === 0) {
    //   this.showWarning("Value selection is mandatory");
    //   return;
    // }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.recordTypePicklistValueId = this.guid.getGUID(
        "recordtypepicklistvalue"
      );
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profilename: localStorage.getItem("crm_profilename"),
      data: {
        recordtype: {
          recordtypepicklistvalue: {
            id: this.recordTypePicklistValueId,
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            mode: this.mode,
            recordtypeid: this.recordTypeId,
            recordtypename: this.recordTypeName,
            picklist: this.fieldLabel,
            values: this.selectedValues,
          },
        },
      },
    };

    console.log("Postoption:", postOption);
    this.isLoading = true;
    this.dataService.upsertRecordTypePicklistValue(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
